import * as React from 'react';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab } from '../../constants/Enums';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';
import { FileList } from '../FileList';

export class FileListTab extends BaseHamburgerTab<{}> {
    protected previous: HamburgerTab = HamburgerTab.DEBUG;

    public render(): JSX.Element {
        return (
            <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                <FileList />
            </HamburgerContentWrapper>
        );
    }

    protected getLabel(): string {
        return 'File-List';
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/FileListTab.tsx